import { orgScopedApiClient } from 'api/orgScopedClient'
import { Organization, OrganizationGroup } from 'types'

import { CerebroPaginatedResponse, CerebroResourceResponse } from '../types'

export const getUserOrganizationGroups = (
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<OrganizationGroup>> =>
    orgScopedApiClient.get(`/api/user/organization_groups/`, {
        params,
    })

export const getUserOrganizations = (
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<Organization>> =>
    orgScopedApiClient.get(`/api/user/organizations/`, { params })

export const getSovPermissions = (): Promise<
    CerebroResourceResponse<{
        read: {
            countries: string[]
            regions: string[]
        }
        write: {
            countries: string[]
            regions: string[]
        }
    }>
> => orgScopedApiClient.get('/api/user/sov_permissions/')
